import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from "moment-timezone";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
function RegularzationApproval() {
  const [employeeData, setemployeeData] = useState([]);
  const { HRreqularzation, MangerApproval, AccessData } = useUserDetails();
  const navigate = useNavigate();
  const [display, setdisplay] = useState(false);
  let Roledata = JSON.parse(sessionStorage.getItem("RegApp"));

  const [Alldata, setAlldata] = useState("");

  const [ID, setID] = useState("");
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  // const getInitData = async (id) => {
  //   const query = `query get_regularization($id:String){
  //              getRegularizationById(id:$id){
  //               id
  //               requestedDate
  //               checkIn
  //               checkOut
  //               reason
  //               lastUpdate
  //               teamleaderId
  //               teamApproval
  //               hrApproval
  //               status
  //               lastUpdate
  //               user{
  //               firstName
  //               }
  //           }
  //           } `;
  //   try {
  //     const response = await axios.post(
  //       BASEURL,
  //       {
  //         query: query,
  //         variables: { id },
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const regularizationRowdata = response.data.data.getRegularizationById;
  //     const weekoffRowdata = response.data.data.getRegularizationById;
  //     setemployeeData(weekoffRowdata);
  //     if (
  //       AccessData &&
  //       Array.isArray(AccessData) &&
  //       AccessData.some(
  //         (item) => item.module === "RegularaizationRequest" && item.component === "ManagerApproval" && item.can_access
  //       )
  //     ) {

  //       setdisplay(true);

  //     }
  //     if (weekoffRowdata.teamApproval == "approved") {
  //       setdisplay(true);
  //     } else if (weekoffRowdata.teamApproval == "rejected") {
  //       setdisplay(false);
  //     }
  //   } catch (error) {
  //     console.error("ResponseError:", error);
  //   }
  // };
  const getInitData = async (id) => {
    const query = `query get_regularization($id:String){
               getRegularizationById(id:$id){
                id
                requestedDate
                checkIn
                checkOut
                reason
                lastUpdate
                teamleaderId
                teamApproval
                hrApproval
                status
                lastUpdate
                user{
                firstName
                }
            }
            } `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const regularizationRowdata = response.data.data.getRegularizationById;
      setAlldata(regularizationRowdata)
      const weekoffRowdata = response.data.data.getRegularizationById;
      setemployeeData(weekoffRowdata);
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "RegularaizationRequest" &&
            item.component === "ManagerApproval" &&
            item.can_access
        )
      ) {
        if (regularizationRowdata.teamApproval == "Pending") {
          setdisplay(true);
        }else {
          setdisplay(false);
        }

        
      } else if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "RegularaizationRequest" &&
            item.component === "HrApproval" &&
            item.can_access
        )
      ) {
        if (Roledata == "HRList") {
          if (regularizationRowdata.teamApproval == "Pending") {
            setdisplay(true);
          }
        } else if (Roledata == "HR") {
          if (
            regularizationRowdata.teamApproval == "approved" &&
            regularizationRowdata.hrApproval == "Pending"
          ) {
            setdisplay(true);
          }
        }
      }

    

    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const checkInTime = moment(employeeData?.checkIn)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");
  const checkOutTime = moment(employeeData?.checkOut)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");

  //   const ApproveSubmit = async (statusdata) => {
  //     let query;

  //     if (HRreqularzation) {

  //       query = `
  //           mutation regularizationHRApprove($id:String $status:String!){
  //   regularizationApproval(id:$id status:$status){
  //     regularizationApprovalHR{
  //       checkIn
  //       checkOut
  //       reason
  //       teamleaderId
  //       status
  //       user{
  //         id
  //       }
  //     }
  //   }
  // }
  //         `;
  //     } else if (MangerApproval) {
  //       query = `
  //           mutation regularizationManagerApprove($id: String, $status: String!) {
  //             regularizationApprovalManager(id: $id, status: $status) {
  //               RegularizationApprovalManager {
  //                 checkIn
  //                 checkOut
  //                 reason
  //                 teamleaderId
  //                 status
  //                 user {
  //                   id
  //                 }
  //               }
  //             }
  //           }
  //         `;
  //     } else {
  //       console.error("Neither HRregularization nor managerState is true.");
  //       return; // Exit if no condition is met
  //     }

  //     const variables = {
  //       id: ID,
  //       status: statusdata,
  //     };

  //     try {
  //       const response = await axios.post(
  //         BASEURL, // Replace with your actual GraphQL endpoint
  //         {
  //           query: query,
  //           variables: variables,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (
  //         response.data.data?.regularizationApproval?.regularizationApprovalHR  !== null
  //       ) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: "Approved successfully!",
  //           showConfirmButton: false,
  //           timer: 2500,
  //         });
  //         navigate('/regularization-request')
  //       } else if (
  //         response.data.data?.regularizationApprovalManager?.RegularizationApprovalManager !== null
  //       ) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: "Approved successfully!",
  //           showConfirmButton: false,
  //           timer: 2500,
  //         });
  //         navigate('/regularization-request')
  //       }
  //       // Handle success (e.g., show a success message or navigate)
  //     } catch (error) {
  //       console.error("Error in ApproveSubmit:", error);
  //       // Handle error (e.g., show a user-friendly error message)
  //     }
  //   };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;

    if (
      AccessData &&
      Array.isArray(AccessData) &&
      AccessData.some(
        (item) => item.component === "HrApproval" && item.can_access
      )
    ) {
      if (Roledata == "HRList") {
        if (Alldata.teamApproval == "Pending") {

          query = `mutation regularizationManagerApprove($id: String, $status: String!) {
             regularizationApprovalManager(id: $id, status: $status) {
               RegularizationApprovalManager {
                 checkIn
                 checkOut
                 reason
                 teamleaderId
                 status
                 user {
                   id
                 }
               }
             }
           }
         `;
        }
      } else if (
        Roledata == "HR" &&
        Alldata.teamApproval == "approved" &&
        Alldata.hrApproval == "Pending"
      ) {
        query = `mutation regularizationHRApprove($id:String $status:String!){
   regularizationApproval(id:$id status:$status){
     regularizationApprovalHR{
       checkIn
       checkOut
       reason
       teamleaderId
       status
       user{
         id
       }
     }
   }
 }
  `;
      }
    } else {
      query = `mutation regularizationManagerApprove($id: String, $status: String!) {
             regularizationApprovalManager(id: $id, status: $status) {
               RegularizationApprovalManager {
                 checkIn
                 checkOut
                 reason
                 teamleaderId
                 status
                 user {
                   id
                 }
               }
             }
           }
         `;
    }

    const variables = {
      id: ID,
      status: statusdata,
    };


    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      if (
        response.data.data?.regularizationApproval?.regularizationApprovalHR !==
        null
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/regularization-request");
      } else if (
        response.data.data?.regularizationApprovalManager
          ?.RegularizationApprovalManager !== null
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/regularization-request");
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/regularization-request");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
        {/* Card Title */}
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              textAlign="center"
              gutterBottom
            >
              Regularization Details
            </Typography>
          }
        />

        {/* Leave Details Content */}
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Manager Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval == "approved"
                      ? "Approved"
                      : employeeData?.teamApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.teamApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Hr Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {/* {employeeData?.hrApproval} */}
                    {employeeData?.hrApproval == "approved"
                      ? "Approved"
                      : employeeData?.hrApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.hrApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong> Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {/* {employeeData?.status} */}
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Check In:</strong>{" "}
                  <span style={{ color: "#67748E" }}>{checkInTime}</span>
                </Typography>
                <Typography variant="h6">
                  <strong>Check Out:</strong>{" "}
                  <span style={{ color: "#67748E" }}>{checkOutTime}</span>
                </Typography>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>
                {/* <Typography variant="h6">
                         <strong>Status:</strong>{" "}
                         <span style={{ color: "#67748E" }}>
                           {employeeData?.status}
                         </span>
                       </Typography> */}
              </Stack>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {display && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}

            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default RegularzationApproval;
